import { useEffect, useState } from "react";

const MaestroNavigation = () => {
  const BASE_URL_IMAGES = `https://console-dev.maestro.maersk.com/`;
  const [productRoutes, setProductRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const json = "https://console-dev.maestro.maersk.com/navigation.json";
    setLoading(true);
    fetch(json)
      .then((response) => response.json())
      .then((data) => {
        setProductRoutes(data ?? []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);
  const rootElement = `#maestro-navigation`;
  const transition = `transition: all 0.3s ease-in-out; transition-delay: 0s;`;
  const styles = {
    image: {
      width: 36,
      height: 36,
      borderRadius: 4,
      marginTop: 4,
      padding: 4,
    },
  };
  return (
    !loading && (
      <div
        style={{
          width: 55,
          height: "100vh",
          padding: `0 0px 0 0`,
          position: "relative",
        }}
      >
        <style>
          {`
            ${rootElement} > * {
                z-index: 9999999999999;
                background: #fff;
                font-family: Maersk Text, maerskText;
            }
            .maestro-navigation-container {
                width: 55px;
                background: #fff;
                border-radius: 4px;
                height: 100%;
                transition: .5s ease-in-out;
                // border-right: 1px solid #ccc;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
                position: fixed;
                ${transition}
            }
            ${rootElement}:hover .maestro-navigation-container {
                width: 220px;
                cursor: pointer;
                ${transition}
                // border-right: 1px solid #CFCFCF;
                background: #FFF;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
            }
            .maestro-navigation-container:hover > * {
                ${transition}
            }
            .maestro-navigation-item {
                display: flex;
                align-items: center;
                text-decoration: none;
                color: black;
                padding: 5px;
                padding-left: 10px;
                ${transition}
            }
            .maestro-navigation-item:hover {
                background: #f5f5f5;
            }
            .maestro-navigation-item:hover .maestro-navigation-item-detail > * {
                font-weight: bold;
            }
            .maestro-navigation-item-detail {
                opacity: 0;
                width: 0;
                display: none;
                ${transition}
                transition: all .9s ease-in-out;
            }
            ${rootElement}:hover .maestro-navigation-item-detail {
                opacity: 1;
                display: block;
                flex: 1;
                transition: all .5s ease-in-out;
                ${transition}
            }
            `}
        </style>
        <div className="maestro-navigation-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "#165469",
              color: "#FFFFFF",
              padding: 10,
            }}
            className="maestro-navigation-item"
          >
            <img
              style={{ height: 36, marginLeft: 0 }}
              src={`${BASE_URL_IMAGES}maestro_logo.svg`}
            ></img>
            <div
              className="maestro-navigation-item-detail"
              style={{ marginLeft: 15 }}
            >
              <b>MAESTRO&nbsp;2.0</b>
            </div>
          </div>
          {productRoutes?.map((product) => {
            return product?.type === "divider" ? (
              <hr />
            ) : (
              <a
                className="maestro-navigation-item"
                href={product?.productLink}
                target="_blank"
              >
                <img
                  style={styles.image}
                  src={`${BASE_URL_IMAGES}${product?.imageUri}`}
                ></img>
                <div className="maestro-navigation-item-detail">
                  <div style={{ marginLeft: 15, whiteSpace: "nowrap" }}>
                    {product?.productName}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    )
  );
};

export default MaestroNavigation;